export const addClientEventLogger = new MyEventWrapper('fast_create_client');
